import { ReactNode } from "react"

interface FormFieldProps {
  label: string
  required?: boolean
  error?: string
  hint?: string
  children: ReactNode
}

export const FormField = ({ label, required, error, hint, children }: FormFieldProps) => (
  <div>
    <label className="text-figmaPrimary jobbin-input-label text-start block">
      {label}
      {required && <span className="text-figmaPrimary"> *</span>}
    </label>
    {hint && <p className="text-xs text-figmaDarkGray mt-1">{hint}</p>}
    <div className="mt-3">{children}</div>
    {error && (
      <p className="mt-2 flex items-center gap-1 text-sm font-medium text-figmaContrast">
        <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4 shrink-0">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 9a1 1 0 012 0v4a1 1 0 11-2 0V9zm1-4a1 1 0 100 2 1 1 0 000-2z"
            clipRule="evenodd"
          />
        </svg>
        {error}
      </p>
    )}
  </div>
)
